import FindMyFriendsHero from './components/FindMyFriendsHero';
import Features from '../../components/sharedComponents/Features';
import HowItWorks from "../../components/sharedComponents/HowItWorks";
import WhyDtp from "../../components/sharedComponents/WhyDtp";
import Testimonials from "../../components/sharedComponents/Testimonials";
import { Helmet } from 'react-helmet';
import { bottomfindMyFriendsFeatures } from './data/bottomfindMyFriendsFeatures';
import { findMyFriendsTestimonials } from "./data/findMyFriendsTestimonials";
import { findMyFriendsFeaturesList } from './data/findMyFriendsFeaturesList';

const FindMyFriends = () => {
    const mediaUrl = process.env.REACT_APP_PUBLIC_CDN_URL;
    return (
        <>
            <Helmet>
                <title>Location Tracking App for Friends - Device Tracker Plus</title>
                <meta name="description" content="Share locations, chat, and check in with friends using the top-rated Find My Friends app. Perfect for nights out, travel, or staying safe day to day." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/find-my-friends" />
            </Helmet>
            <FindMyFriendsHero mediaUrl={mediaUrl}/>
            <Features sectionTitle="Features Designed for Friends" features={findMyFriendsFeaturesList} mediaUrl={mediaUrl}/>
            <HowItWorks stepOne="Sign up online" stepTwo="Register device" stepThree="Start Tracking" />
            <Testimonials testimonials={findMyFriendsTestimonials} />
            <WhyDtp reasons={bottomfindMyFriendsFeatures} title="How Friends Use Device Tracker Plus"/>

        </>
    );
}

export default FindMyFriends;